<template>
  <!--  课程卡片  -->
  <div class="container" @click="goDetail">
    <div class="img-box">
      <img :src="data.cover" class="poster" alt="">
      <div class="is-good g-font-14" v-if="data.isGood">精品课程</div>
      <div class="study-box">
        <div>
          <span>{{ data.status === '未学习' ? data.status : data.status + data.mediaProgress + '%' }}</span>
          <el-progress v-if="data.status !== '未学习'" style="width: 60px;margin-left: 8px" color="#08D1AD"
                       :show-text="false"
                       :percentage="data.mediaProgress"></el-progress>
        </div>
        <div>{{ data.duration }}</div>
      </div>
    </div>
    <div class="white-bg " >
      <div class="g-p-15">
        <el-tooltip class="item" effect="dark" :content="data.name" placement="top">
          <p class="g-show-1-line g-font-16">{{ data.nameEllipsis }}</p>
        </el-tooltip>
        <div class="g-flex g-row-between g-font-12 g-m-t-10">
          <p><span class="green-text">{{ data.studyCount }}</span><span>学习过</span></p>
          <p class="remark-text">{{ data.chapterSectionInfo }}</p>
        </div>
        <div class="line"></div>
        <div class="g-flex g-row-between">
          <p class="red-text g-weight-font g-font-20">{{ data.price === '0.00' ? '免费' : '￥' + data.price }}</p>
          <div class="g-flex g-font-14">
            <div class="submit-btn g-nowrap" v-if="data.isExam">去考试</div>
            <div class="submit-btn g-m-l-10 g-nowrap">去学习</div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "course-card",
  props: {
    data: {
      type: Object,
    }
  },
  data() {
    return {}
  },
  methods: {
    goDetail() {
      this.$router.push('/course-detail/' + this.data.id)
    }
  }
}
</script>

<style lang="scss" scoped>
.poster {
  width: 285px;
  height: 180px;
  border-radius: 5px 5px 0 0;
  display: block;
}

.white-bg {
  background: #fff;
  width: 285px;
  border-radius: 0 0 5px 5px;
}
.container{
  cursor:pointer;
}
.line {
  height: 1px;
  width: 100%;
  background: #f7f7f7;
  margin: 15px 0;
}

.submit-btn {
  padding: 3px 14px !important;
}

.img-box {
  width: 285px;
  height: 180px;
  position: relative;

  img {
    position: absolute;
  }

  .is-good {
    position: absolute;
    top: 15px;
    width: 85px;
    height: 27px;
    line-height: 27px;
    text-align: center;
    background: #1db599;
    color: #FFFFFF;
    z-index: 11;
    border-radius: 0px 20px 20px 0px;
  }

  .study-box {
    position: absolute;
    width: 285px;
    bottom: 0;
    height: 35px;
    background: rgba(0, 0, 0, 0.70);
    display: flex;
    justify-content: space-between;
    color: #FFFFFF;
    font-size: 12px;

    div {
      line-height: 35px;
    }

    div:nth-child(1) {
      display: flex;
      align-items: center;
      margin-left: 16px;
    }

    div:nth-child(2) {
      margin-right: 16px;
    }
  }
}

</style>
